import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const PersonIcon: React.FC<
  JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
> = (props) => {
  const iconColor = props.className?.includes('red') ? 'red' : 'gray';
  return (
    <svg
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{
        width: '24px',
        height: '24px',
        margin: '0 10px',
        color: iconColor,
      }}
      {...props}
    >
      <circle
        cx={24}
        cy={11}
        r={7}
        fill='none'
        stroke={iconColor}
        strokeWidth={4}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4 41C4 32.1634 12.0589 25 22 25'
        stroke={iconColor}
        strokeWidth={4}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M31 42L41 32L37 28L27 38V42H31Z'
        fill='none'
        stroke={iconColor}
        strokeWidth={4}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default PersonIcon;
